import type { Nullable } from "@msuite/utils/types";
import { Icon } from "../icons";
import { localized } from "../localization";
import { cn } from "../utils";

/** Props Interface */
interface YesNoTagProps {
	value: Nullable<boolean | "yes" | "no">;
}

export function YesNoTag({ value }: YesNoTagProps) {
	return (
		<div className="h-stack">
			<Icon
				name={value ? "CircleCheck" : "CircleSlash"}
				className={cn(
					value ? "stroke-emerald-500" : "stroke-red-500",
					value ? "fill-emerald-500/10" : "fill-red-500/10",
				)}
			/>
			<p>{value ? localized("general.yes") : localized("general.no")}</p>
		</div>
	);
}
